import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// service imports
import { FileReaderService } from '../../../../../_services/shared-services/file-reader.service';
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { WorkflowReimbursementRequestService } from '../../../../_services/workflow-reimbursement-request.service';

// model imports
import { AttachmentParameterDto } from '../../../../../_models/attachment-parameter-dto';
import { WFReimbursementAttachReceiptParametersDto } from '../../../../_models/workflow-reimbursement-request/wf-reimbursement-attach-receipt-parameters-dto';

// constant imports
import { MessageInterval } from '../../../../../_constants/messages-intervals';

@Component({
    selector: 'app-attach-receipt',
    templateUrl: './attach-receipt.component.html',
    styleUrls: ['./attach-receipt.component.scss']
})
export class AttachReceiptComponent implements OnInit {
    @ViewChild('uploadInvoicePopup', { static: false }) uploadInvoicePopup: DxPopupComponent;

    @Input() lineItemWorkflowId: number;
    @Input() communityId: number;
    @Output() onClose = new EventEmitter<boolean>();

    visible = false;

    uploadedFile: File[] = [];
    reimbursementReceipt: WFReimbursementAttachReceiptParametersDto;

    iconCancel = IconConstants.CANCEL;
    iconCheck = IconConstants.CHECK;

    loadingVisible = false;

    constructor(
        private readonly fileReader: FileReaderService,
        private readonly workflowReimbursementService: WorkflowReimbursementRequestService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.reimbursementReceipt = new WFReimbursementAttachReceiptParametersDto();
        this.reimbursementReceipt.lineItemWorkflowId = this.lineItemWorkflowId;
        this.reimbursementReceipt.communityId = this.communityId;
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.uploadInvoicePopup.instance.repaint();
    }

    onPopupClose(): void {
        this.visible = false;
        this.closeUploader();
    }

    onFileUpload(): void {
        if (Utils.notNullOrEmpty(this.uploadedFile)) {
            this.fileReader.readFile(this.uploadedFile[0]).subscribe((result: AttachmentParameterDto) => {
                this.reimbursementReceipt.filename = result.fileName;
                this.reimbursementReceipt.fileBase64String = result.attachmentBase64;
            });
        }
    }

    onCancelClick(): void {
        this.closeUploader();
    }

    onSubmitClick(): void {
        this.submitReceipt();
    }

    private submitReceipt(): void {
        this.loadingVisible = true;
        this.workflowReimbursementService.attachLineItemReceipt(this.reimbursementReceipt).subscribe(
            (result: any) => {
                notify('Receipt Attached Successfully!', 'Success', MessageInterval.successMsgInterval);
                this.closeUploader(true);
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    private closeUploader(clearCache = false): void {
        this.onClose.emit(clearCache);
    }
}
